"use client";

import { useEffect } from "react";
import type { RuntimePublicConfig } from "@/lib/config/publicRuntimeConfig";

interface RuntimeConfigBridgeProps {
  config: RuntimePublicConfig;
}

export function RuntimeConfigBridge({ config }: RuntimeConfigBridgeProps) {
  useEffect(() => {
    (
      window as Window & {
        __IKAI_RUNTIME_CONFIG__?: RuntimePublicConfig;
      }
    ).__IKAI_RUNTIME_CONFIG__ = config;
  }, [config]);

  return null;
}
